export class EditUserDataSend {

	CodAgencia: string;
	NroConta: string;
	CPF: string;
	NomeCompleto: string;
	Celular: string;
	Email: string;
	Brasileiro: true;
	UF: string;
	Naturalidade: string;
	NomeMae: string;
	DataNascimento: Date;
	RG: string;
	Sexo: string;
	Editavel: boolean;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/user-admin/models/edit-user-data-send.ts